import React, { useEffect, useRef } from 'react';

const CopilotInform = ({ htmlContent }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const adjustIframeHeight = () => {
      if (iframeRef.current) {
        const iframeDoc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
        if (iframeDoc && iframeDoc.body) {
          iframeRef.current.style.height = `${iframeDoc.body.scrollHeight}px`;
        }
      }
    };

    const uniqueId = `id_${Math.random().toString(36).substring(2, 11)}`;

    // Modify the HTML content to make all variable declarations unique
    let modifiedContent = htmlContent;

    // Handle chartExportConfiguration variable
    modifiedContent = modifiedContent.replace(
      'const chartExportConfiguration =',
      `const chartExportConfiguration_${uniqueId} =`
    )

    modifiedContent = modifiedContent.replace(
      /Plotly\.newPlot\('grafico_(\d+)'.*?, chartExportConfiguration\)/g,
      (match) => match.replace('chartExportConfiguration)', `chartExportConfiguration_${uniqueId})`)
    );

    // Handle all data_X variables
    modifiedContent = modifiedContent.replace(
      /const data_(\d+) =/g,
      (match, number) => `const data_${number}_${uniqueId} =`
    );

    // Handle references to data_X in Plotly.newPlot calls
    modifiedContent = modifiedContent.replace(
      /Plotly\.newPlot\('grafico_(\d+)', data_(\d+),/g,
      (match, graphNum, dataNum) => `Plotly.newPlot('grafico_${graphNum}', data_${dataNum}_${uniqueId},`
    );

    // Handle all layout_X variables
    modifiedContent = modifiedContent.replace(
      /const layout_(\d+) =/g,
      (match, number) => `const layout_${number}_${uniqueId} =`
    );

    // Handle references to layout_X in Plotly.newPlot calls
    modifiedContent = modifiedContent.replace(
      /chartConfig\(layout_(\d+)\)/g,
      (match, number) => `chartConfig(layout_${number}_${uniqueId})`
    );

    if (iframeRef.current) {
      const iframe = iframeRef.current;
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

      if (iframeDoc) {
        // Escribir el contenido dentro del iframe
        iframeDoc.open();
        iframeDoc.write(modifiedContent);
        iframeDoc.close();

        // Esperar a que el contenido del iframe esté completamente cargado
        iframe.onload = adjustIframeHeight;
      }
    }

    return () => {
      if (iframeRef.current) {
        iframeRef.current.onload = null; // Limpiar el evento al desmontar
      }
    };
  }, [htmlContent]);

  return (
    <iframe
      ref={iframeRef}
      className="w-full h-full border-none"
    />
  );
};

export default CopilotInform;
